module.exports = __webpack_public_path__ + "static/img/8-7.5b33acc8.jpg";